// extracted by mini-css-extract-plugin
export default {"main_container_nav":"nav_main_container_nav__BBbaw","nav_content":"nav_nav_content__aboA1","nav_title":"nav_nav_title__j1Bx9","nav_btns":"nav_nav_btns__XC5D5"};